import { ArrowLeftOutlined, MailOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';

interface CompareProps {
    text: string;
    onClick: () => void;
}

interface ShareProps extends CompareProps {}
interface BackProps extends CompareProps {}

export const Compare = ({ text, ...props }: CompareProps) => (
    <Button icon={<PlusCircleOutlined />} size="small" type="text" {...props}>
        {text}
    </Button>
);

export const Share = ({ text, ...props }: ShareProps) => (
    <Button icon={<MailOutlined />} size="small" type="text" {...props}>
        {text}
    </Button>
);

export const Back = ({ text, ...props }: BackProps) => (
    <Button icon={<ArrowLeftOutlined />} size="small" type="text" {...props}>
        {text}
    </Button>
);

export const StyledButton = styled(Button)`
    color: #fff;
    height: 60px;
    margin-left: 5px;
    margin-right: 5px;
    border: none;
    font-size: 1.35rem;
    font-weight: 400;
    background-color: ${props => props.theme.antd['text-color']};
    pointer-events: none;
`;

export const GridBox = styled.div<{ size: number }>`
    display: grid;
    place-items: stretch;
    -webkit-box-align: stretch;
    place-content: start stretch;
    grid-template-columns: ${props => Array.from({ length: props.size }, () => 'minmax(0, 2fr)').join(' ')};
    gap: 5px;
`;
